interface BannerProps {
  icon: JSX.Element;
  text: string;
  className?: string;
}

export function Banner({ icon, text, className }: BannerProps) {
  return (
    <div
      className={`flex gap-4 p-4 ${className} rounded-[10px] bg-gray-50`}
      data-cy="banner"
    >
      <div className="w-5">{icon}</div>
      <span className="text-body">{text}</span>
    </div>
  );
}
